import { OfferingStatus } from '@arrived/models';

export const canOfferingStatusReserveShares = (offeringStatus?: OfferingStatus): boolean => {
  if (!offeringStatus) {
    return false;
  }

  return offeringStatus === OfferingStatus.RESERVATIONS;
};
